import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetSupplierChanges(params) {
  // it receives supplier id and date and gets data / file changes
  const res = await api.get(
    routes.SUPPLIER_CHANGES + "/get_supplier_changes/",
    {
      params: params,
    }
  );

  return res;
}
